import { render, staticRenderFns } from "./SpDialog.vue?vue&type=template&id=22303852&"
import script from "./SpDialog.vue?vue&type=script&lang=js&"
export * from "./SpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports